<template>
	<div class="accordion" id="market-information">
		<div class="card shadow-sm mg-b-40">
			<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
				<div>
					<h6 class="mg-b-5">
						<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseEquityAvailable" aria-expanded="true" aria-controls="collapseEquityAvailable">
							Equities Available
						</button>
					</h6>
					<p class="tx-13 tx-color-03 mg-b-0"></p>
				</div>
			</div>
			<div id="collapseEquityAvailable" class="collapse show" data-parent="#market-information">
				<div class="card-body market-information pd-y-30">
					<div class="table-responsive">
						<table class="table table-dashboard mg-b-0" aria-describedby="market-information-table">
							<thead>
								<tr>
									<th scope="col" class="text-center">Company</th>
									<th scope="col" class="tx-medium text-center">Ticker</th>
									<th scope="col" class="tx-medium text-center">Price</th>
									<th scope="col" class="tx-medium text-center">1 Day Change</th>
									<th scope="col" class="tx-medium text-center">1 Yr Performance</th>
									<th scope="col" class="tx-medium text-center">1 Yr High</th>
									<th scope="col" class="tx-medium text-center">1 Yr Low</th>
									<th scope="col" class="tx-medium text-center">Your Holdings</th>
									<th scope="col" class="tx-medium text-center">Trade Options</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(equity, index) in marketData" :key="index">
									<td class="text-center" v-tooltip:top="equity.symbol_name">
										<img :src="stockImages[equity.symbol]" :alt="equity.symbol" class="mw-100" height="50" width="50" />
									</td>
									<td class="tx-color-03 tx-medium text-center" v-tooltip:top="equity.symbol_name">{{ equity.symbol }}</td>
									<td class="tx-medium text-center">{{ calculatePrice(equity) | toNumber }}</td>
									<td class="tx-medium text-center">{{ calculateDayChange(equity) | toNumber }}</td>
									<td class="tx-medium text-center">
										<year-performance-component :stock-code="equity.stock_code" :performance="equity.yearPerformance"></year-performance-component>
									</td>
									<td class="tx-medium text-center">{{ equity.year_high | toNumber }}</td>
									<td class="tx-medium text-center">{{ equity.year_low | toNumber }}</td>
									<td class="tx-medium text-center">{{ equity.holding }}</td>
									<td class="tx-medium">
										<button type="button" class="btn btn-sm btn-primary shadow-sm" @click="selectEquity(equity.stock_code)">Trade</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { trade } from '../../../../../mixins';

export default {
	mixins: [trade.equities],
	data() {
		return {};
	},
	methods: {
		selectEquity(stock) {
			this.$emit('select-equity', stock);
		},
	},
	props: {
		marketData: {
			type: Array,
			required: true,
		},
		yearPerformances: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style>
</style>